import React from 'react';
import { Button, Modal, Typography } from '@attentive-platform/stem-ui';

import { UnlinkModalStyles as S } from './styles';

const EFFECTS = [
  'This company must stay on a Rosetta scope record — you cannot drop back to free-form.',
  'Pick another submitted scope record to become the new scope of record.',
  'The current record stays in the console and can be linked again later.'
];

const UnlinkModal = ({ show, onClose, onConfirm }) => (
  <Modal
    show={show}
    onClose={onClose}
    heading={<span className='pl-4'>Replace scope record</span>}
    content={
      <S.ContentWrap>
        <S.Heading>Link another scope record to replace this one</S.Heading>
        <Typography variant='body2' color='#4D4D4D' sx={{ lineHeight: 1.6 }}>
          Unlinking is only allowed as a swap. You must link a different scope record before this one is replaced.
        </Typography>
        <S.Effects>
          {EFFECTS.map(text => (
            <S.BulletRow key={text}>
              <S.BulletDot />
              <Typography variant='body3' color='#4D4D4D' sx={{ lineHeight: 1.55 }}>
                {text}
              </Typography>
            </S.BulletRow>
          ))}
        </S.Effects>
        <S.NoteBox>
          <Typography variant='body4' color='#4D4D4D' sx={{ lineHeight: 1.55 }}>
            Takeoffs already submitted keep the scope snapshot pinned to them — replacing the record does not change
            work already in flight.
          </Typography>
        </S.NoteBox>
        <S.Actions>
          <Button variant='outlined' color='primary' size='medium' onClick={onClose}>
            Cancel
          </Button>
          <Button variant='contained' color='primary' size='medium' onClick={onConfirm}>
            Link another scope record
          </Button>
        </S.Actions>
      </S.ContentWrap>
    }
  />
);

export default UnlinkModal;
